import { AppealAddressTypeEnum } from '../appeal-address-type.enum';
import { IAppealInfo } from '../appeal-info.model';
import { IAppealsDraftForm } from '../appeal.model';
import { IAppealSubmitRequest, IAppealSubmitted } from './appeal-submit-request.model';
import { AppealDocumentCategory, AppealType } from '../appeal-type.model';
import { AppealContactCategoryEnum } from '@carm/_core/appeals/models/appeals.model';
import { CaseTypes } from '@carm/_core/program-enrolment/models/enrol-program-enums.model';

export const mapAppealDraftToRequest = (draft: IAppealsDraftForm, appealInfo: IAppealInfo): IAppealSubmitRequest => {

    let serviceRequestType = '';
    switch (appealInfo.appealType) {
        case AppealType.Rulings:
            serviceRequestType = CaseTypes.ZAPP;
            break;
        case AppealType.Enforcements:
            serviceRequestType = appealInfo.penaltyReductionAgreement ? CaseTypes.ZRED : CaseTypes.ZAPP;
            break;
        case AppealType.TT:
            serviceRequestType = CaseTypes.ZTTA;
            break;
    }

    return {
        appealType: appealInfo.documentCategory,
        serviceRequestType,
        consent: true,
        requestForExtension: appealInfo.appealRequiresRFE,
        classificationNumber: draft.appealDetails.classificationNumber,
        referenceCaseNumber: appealInfo.caseNumber,
        penaltyReductionAgreement: draft.appealDetails?.penaltyReductionAgreement,
        justification: draft.appealDetails.reason,
        extensionReason1: draft.rfe?.withinTimeJustification,
        extensionReason2: draft.rfe?.applicationJustification,
        extensionReason3: draft.rfe?.circumstancesJustification,
        primaryContactInfo: {
            contactCategory: draft.contactInfo.contactCategory,
            contactType: draft.contactInfo.contactType,
            addressType: draft.contactInfo.contactCategory === AppealContactCategoryEnum.Corporation ?
                                AppealAddressTypeEnum.Coporation : AppealAddressTypeEnum.Individual,
            firstName: draft.contactInfo.contactCategory === AppealContactCategoryEnum.Individual ?
                                draft.contactInfo.individual?.firstName : draft.contactInfo?.company?.contact,
            lastName: draft.contactInfo.individual?.lastName,
            line1: draft.contactInfo.address.line1,
            line2: draft.contactInfo.address.line2,
            town: draft.contactInfo.address.town,
            region: draft.contactInfo.address.region,
            country: draft.contactInfo.address.country,
            postalCode: draft.contactInfo.address.postalCode,
            companyName: draft.contactInfo.company?.name,
            phone: draft.contactInfo.address.phone,
            email: draft.contactInfo.email
        },
        tradePrograms: {
            marking: false,
            origin: false,
            safeguard: false,
            sima: false,
            tariffClassification: false,
            valuation: false
        }
    };
};

export const mapAppealRequestToForm = (submittedAppeal: IAppealSubmitted): IAppealsDraftForm => {

    let appealType = '';

    switch (submittedAppeal.appealType) {
        case AppealDocumentCategory.Rulings:
            appealType = AppealType.Rulings;
            break;
        case AppealDocumentCategory.Enforcements_Ascertain_Forfeiture:
        case AppealDocumentCategory.Enforcements_Notice_Seizure:
        case AppealDocumentCategory.Enforcements_Penalty:
        case AppealDocumentCategory.Enforcements_Seizure:
            appealType = AppealType.Enforcements;
            break;
        case AppealDocumentCategory.TT_Cancelled_Authorization:
        case AppealDocumentCategory.TT_Denied_Enrolment:
        case AppealDocumentCategory.TT_Suspended_Authorization:
            appealType = AppealType.TT;
            break;
    }

    return {
        appealType,
        requestForExtension: submittedAppeal.requestForExtension,
        caseNumber: submittedAppeal.referenceCaseNumber,
        appealDetails: {
            reason: submittedAppeal.justification,
            classificationNumber: submittedAppeal.classificationNumber,
            penaltyReductionAgreement: submittedAppeal.penaltyReductionAgreement
        },
        rfe: {
            withinTimeJustification: submittedAppeal.extensionReason1,
            applicationJustification: submittedAppeal.extensionReason2,
            circumstancesJustification: submittedAppeal.extensionReason3,
            requestForExtension: submittedAppeal.requestForExtension,
        },
        contactInfo: {
            contactCategory: submittedAppeal.primaryContactInfo?.contactCategory,
            contactType: submittedAppeal.primaryContactInfo?.contactType,
            individual: {
                firstName: submittedAppeal?.primaryContactInfo?.firstName,
                lastName: submittedAppeal?.primaryContactInfo?.lastName
            },
            company: {
                name: submittedAppeal?.primaryContactInfo?.companyName,
                contact: submittedAppeal?.primaryContactInfo?.firstName
            },
            address: {
                country: submittedAppeal?.primaryContactInfo?.country,
                line1: submittedAppeal?.primaryContactInfo?.line1,
                line2: submittedAppeal?.primaryContactInfo?.line2,
                postalCode: submittedAppeal?.primaryContactInfo?.postalCode,
                region: submittedAppeal?.primaryContactInfo?.region,
                town: submittedAppeal?.primaryContactInfo?.town,
                phone: submittedAppeal?.primaryContactInfo?.phone
            },
            registerForEmail: submittedAppeal?.primaryContactInfo?.email?.trim() !== '' && submittedAppeal?.primaryContactInfo?.email ? 'yes' : 'no',
            email: submittedAppeal?.primaryContactInfo?.email
        }
    };
};
